import { useRouter } from 'next/router';
import {
	CURR_URL_SESSION_STORAGE_KEY,
	PREV_URL_SESSION_STORAGE_KEY,
} from 'presentation/events/constants/eventConstants';
import { safeDecodeUrl } from 'presentation/events/utils/ga4Utils';
import { useEffect } from 'react';

export const usePreviousUrl = () => {
	const router = useRouter();

	useEffect(() => {
		const update = (nextUrl: string) => {
			const decoded = safeDecodeUrl(nextUrl);
			const storage = window.sessionStorage;
			const prevCurrent = storage.getItem(CURR_URL_SESSION_STORAGE_KEY);
			// Skip when URL didn't actually change (refresh, replaceState, etc.)
			// so the existing previous URL is preserved.
			if (prevCurrent === decoded) return;
			if (prevCurrent) {
				storage.setItem(PREV_URL_SESSION_STORAGE_KEY, prevCurrent);
			}
			storage.setItem(CURR_URL_SESSION_STORAGE_KEY, decoded);
		};

		// Covers hard loads (refresh, external redirects, deep links) that
		// don't trigger Next.js' routeChangeComplete.
		update(window.location.href);

		const handle = (url: string) => update(new URL(url, window.location.origin).href);
		router.events.on('routeChangeComplete', handle);

		return () => {
			router.events.off('routeChangeComplete', handle);
		};
	}, [router.events]);
};
